import { render, staticRenderFns } from "./sku-img-upload.vue?vue&type=template&id=4202d9de&"
import script from "./sku-img-upload.vue?vue&type=script&lang=js&"
export * from "./sku-img-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports